module.exports = __webpack_public_path__ + "img/2.cfc843ec.jpg";